// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"it_a bgu_je","CommentListPlaceholder--Legacy":"it_b bgu_qh bgu_vk"};